import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'United Hands Karur Shop | Local Business Directory',
  description = 'Discover the best local businesses and shops in Karur. Browse categories, read reviews, and find trusted businesses in your community.',
  keywords = 'Karur shops, Karur businesses, local business directory, Karur shopping, shop listings, business reviews',
  ogImage = 'https://yourwebsite.com/og-image.jpg',
  ogType = 'website',
  canonicalUrl,
  author = 'United Hands Karur Shop',
  structuredData,
}) => {
  const siteUrl = 'https://yourwebsite.com';
  const fullUrl = canonicalUrl || window.location.href;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />

      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="United Hands Karur Shop" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
